import DataPill from "@components/pills/DataPill";
import { userManagementApis } from "@services/apis/UserManagement";
import { DefaultConfigResponse } from "@services/models/UserManagement/get-services";
import { useEffect, useState } from "react";
import { Menu, MenuItem, Sidebar } from "react-pro-sidebar";
import CPGConfigContainer from "./services/CPGConfig";
import OpenBankingConfig from "./services/OpenBankingConfig";

interface ServicesProps {
  userId: number;
  accountType: string;
}

const Services: React.FC<ServicesProps> = ({ userId, accountType }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [services, setServices] = useState<DefaultConfigResponse | null>(null);
  const [collapsed, setCollapsed] = useState(true);
  const [selectedTab, setSelectedTab] = useState<string>("");

  const getServices = async () => {
    setLoading(true);

    try {
      const response = await userManagementApis.getUserConfig({ userId });
      setServices(response.data);
      setSelectedTab("CPG");
      if (collapsed) {
        setCollapsed(false);
      }
    } catch (error) {
      console.error("Error fetching services:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getServices();
  }, [userId, accountType]);

  const handleTabChange = (tab: string) => {
    setSelectedTab(tab);
  };

  if (loading) {
    return (
      <div className="p-[16px] rounded-lg border border-border-subtle bg-bg-base mt-[16px]">
        <div className="flex items-center justify-center py-[20px]">
          <span className="text-[12px] text-text-disabled">
            Loading services...
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="flex w-full">
      <Sidebar
        collapsed={collapsed}
        collapsedWidth="60px"
        width="260px"
        backgroundColor="#F8F8F8"
        onMouseEnter={() => setCollapsed(false)}
        onMouseLeave={() => setCollapsed(true)}>
        <Menu
          menuItemStyles={{
            button: {
              padding: "8px 12px",
            },
            label: {
              fontSize: "12px",
              fontWeight: 500,
            },
          }}>
          {services?.services &&
            Object.entries(services.services).map(([serviceName, config]) => (
              <MenuItem
                key={serviceName}
                className={
                  selectedTab.toLowerCase() === serviceName.toLowerCase()
                    ? "text-text-navbar-active"
                    : "text-text-base"
                }
                onClick={() => handleTabChange(serviceName)}
                icon={
                  <span className="material-symbols-outlined text-[18px]">
                    widgets
                  </span>
                }>
                {!collapsed && (
                  <div className="flex justify-between w-full items-center">
                    <span className="font-medium text-[12px]">
                      {serviceName}
                    </span>

                    <div className="flex gap-[8px] items-center">
                      <DataPill
                        value={config?.enabled ? "enabled" : "disabled"}
                      />
                    </div>
                  </div>
                )}
              </MenuItem>
            ))}
        </Menu>
      </Sidebar>
      {selectedTab.toLowerCase() === "cpg" && (
        <CPGConfigContainer
          cpgData={services?.services?.CPG}
          fullConfig={services!}
          userId={userId}
        />
      )}
      {selectedTab.toLowerCase() === "openbanking" && <OpenBankingConfig />}
    </div>
  );
};

export default Services;
